export const DRIFT_PRIORITY_PATHS = ['/request-demo-ty/']
